/**
 * Centralised app version + copyright strings. Iter 75.
 *
 * Update this file (and ./CHANGELOG.md) on every release. The Landing /
 * AppLayout / About / Public Share view all read from here so a single bump
 * propagates everywhere.
 */
export const APP_VERSION = '1.0.0';
export const APP_RELEASE_DATE = '2026-02';
export const APP_COPYRIGHT_YEAR = '2024–2026';
export const APP_COPYRIGHT = `© ${APP_COPYRIGHT_YEAR} Physiogenic`;
export const APP_LEGAL_LINE = `${APP_COPYRIGHT} · All rights reserved.`;

/** Used in <title> tags and shareable previews. */
export const APP_FULL_NAME = 'Physiogenic';
export const APP_TAGLINE = 'Clinic management for physiotherapy, osteopathy, chiropractic & massage';

/** ISO short hand for footer signature. */
export const APP_BUILD_SHORT = `v${APP_VERSION}`;
